<template>
  <div>
    <tagSuggest
      v-if="tagItems.length"
      :tagItems="tagItems"
      @changeSelectedIndex="changeSelectedIndex"
      @tag-clicked="clickTag"
    />
    <div v-show="!tagItems.length && !keyword">
      <quick @typeClicked="typeClicked" />
      <recent v-if="rencentList.length" @keywordClicked="handleKeywordClicked" />
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    rencentList() {
      return this.$store.getters['search/keywordsList']
    },
  },
  data() {
    return {
      tagItems: [],
      keyword: '',
    }
  },
  components: {
    quick: () => import('./quick.vue'),
    recent: () => import('./recent.vue'),
    tagSuggest: () => import('./tagSuggest.vue'),
  },
  methods: {
    changeSelectedIndex(index) {
      this.$emit('changeSelectedIndex', index)
    },
    typeClicked(type) {
      this.$emit('typeClicked', type)
    },
    setSearchResult(result, val) {
      this.tagItems = result
      this.keyword = val
    },
    clickTag(item) {
      this.$emit('tag-clicked', item)
      this.tagItems = []
      this.keyword = ''
    },
    async handleKeywordClicked(keyword) {
      //await this.$store.dispatch('resetFilter')
      this.$store.commit('setStartDate', null)
      this.$store.commit('setEndDate', null)
      this.$store.commit('setPinnedSelectedTag', null)
      this.$store.commit('setSelectedTag', null)
      this.$store.commit('setType', null)
      this.$store.commit('setSelectedSource', 'search')
      this.$store.commit('setQuery', keyword)
      let url = '/mine?source=search&query=' + keyword
      window.history.pushState(null, null, url ? url : '?')
      this.$emit('recentClicked', keyword)
    },
  },
}
</script>
<style lang="scss" scoped></style>
